















import { Vue, Component, Prop } from 'vue-property-decorator';
import SearchHeader from './search-header.vue';
import CategoryTree from './category-tree.vue';

/**
 * CTI目录头部信息
 *
 * @author xiaokunyu
 * @date 01/11/2019
 */
@Component({
    components: {
        CategoryTree,
        SearchHeader
    }
})
export default class CatalogHeader extends Vue {
    @Prop({
        default: () => [
            {
                title: '一级目录',
                count: 0
            },
            {
                title: '二级目录',
                count: 0
            },
            {
                title: '三级目录',
                count: 0
            }
        ]
    })
    header: Array<{ title: string; count: number }>;

    handleCategoryChange(val) {
        this.$emit('change', val);
    }
    clearEvent() {
        this.$emit('clear');
    }
}
